module.exports = __webpack_public_path__ + "img/06.82085e4a.jpg";